
export const host = "https://weeatapi.herokuapp.com";
//export const host = "http://localhost:4000"